import BusinessType from "../Contacts/BusinessType";
import PrimaryContact from "../Contacts/PrimaryContact";
import OrganisationContact from "../Contacts/OrganisationContact";


const SellerFormBuyerContacts = ({
  register,
  watch,
  control,
  errors,
  getFieldState,
  clearErrors,
  isCompanyFieldName,
  setError,
  uploadSizeLimit = 0,
  setValue
}) => {

  return (
    <>
      <div className="br-box">
        <div className="br-title">Details of Buyer</div>
        <BusinessType
          register={register}
          watch={watch}
          getFieldState={getFieldState}
          isCompanyFieldName={isCompanyFieldName}
        />
      </div>

      <PrimaryContact
        register={register}
        watch={watch}
        control={control}
        errors={errors}
        getFieldState={getFieldState}
        clearErrors={clearErrors}
        isCompanyFieldName={isCompanyFieldName}
        isDocNeededForOrg={true}
        setError={setError}
        uploadSizeLimit={uploadSizeLimit}
        prefixIsCompanyField="buyer"
        setValue={setValue}
      />

      {/* Organisation Contact */}
      {watch(`${isCompanyFieldName}`) === "Organisation" && (
        <OrganisationContact 
          register={register}
          watch={watch}
          control={control}
          errors={errors}
          getFieldState={getFieldState}
          clearErrors={clearErrors}
          prefixIsCompanyField="buyer"
        />
      )}
    </>
  );
};

export default SellerFormBuyerContacts;
